var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnlineMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22414_12642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49468 56.7525H32.3335V54.6876H5.49468C3.78446 54.6876 2.39792 53.301 2.39792 51.5908V6.17144C2.39792 4.4607 3.78446 3.07468 5.49468 3.07468H50.9141C52.6251 3.07468 54.0108 4.4607 54.0108 6.17144V29.9132H56.0758V6.17144C56.0724 3.32228 53.7635 1.01362 50.9141 1.01025H5.49468C2.64604 1.01362 0.337118 3.32228 0.333496 6.17144V51.5908C0.337118 54.44 2.64604 56.7486 5.49468 56.7525Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46282 5.13909H6.52698V7.20325H4.46282V5.13909Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59136 5.13909H10.6563V7.20325H8.59136V5.13909Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7207 5.13909H14.7853V7.20325H12.7207V5.13909Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46282 9.269H51.9464V11.3339H4.46282V9.269Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0876 13.699L12.4656 16.3209C10.2493 14.8537 7.2814 15.3039 5.59939 17.3623C3.91763 19.4206 4.06847 22.4187 5.9479 24.2979C7.82707 26.1778 10.8255 26.3287 12.884 24.6467C14.9422 22.9649 15.3926 19.9965 13.9251 17.7807L16.5468 15.1587L15.0876 13.699ZM9.62344 23.7189C7.91348 23.7189 6.52694 22.3326 6.52694 20.6224C6.52694 18.9119 7.91348 17.5259 9.62344 17.5259C10.084 17.5274 10.537 17.633 10.9502 17.835L8.89408 19.8914L10.3533 21.3512L12.411 19.2961C12.6131 19.709 12.7189 20.1621 12.7205 20.6224C12.7205 22.3326 11.3344 23.7189 9.62344 23.7189Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 17.5265H35.4299V19.5906H17.8819V17.5265Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 21.6548H25.1075V23.719H17.8819V21.6548Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1722 21.6548H41.6234V23.719H27.1722V21.6548Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4947 17.5265H47.8174V19.5906H37.4947V17.5265Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0876 26.0863L12.4656 28.7083C10.2493 27.2411 7.2814 27.6913 5.59939 29.7497C3.91763 31.8082 4.06847 34.8061 5.9479 36.6858C7.82707 38.5652 10.8255 38.7161 12.884 37.0341C14.9422 35.3521 15.3926 32.3847 13.9251 30.1681L16.5468 27.5461L15.0876 26.0863ZM9.62344 36.1065C7.91348 36.1065 6.52694 34.72 6.52694 33.0098C6.52694 31.2993 7.91348 29.9127 9.62344 29.9127C10.084 29.9145 10.537 30.0204 10.9502 30.2224L8.89408 32.2794L10.3533 33.7386L12.411 31.6832C12.6131 32.0964 12.7189 32.5495 12.7205 33.0098C12.7205 34.72 11.3344 36.1065 9.62344 36.1065Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 29.9133H35.4299V31.978H17.8819V29.9133Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 34.0422H25.1075V36.1067H17.8819V34.0422Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1722 34.0422H35.43V36.1067H27.1722V34.0422Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4947 29.9133H41.6236V31.978H37.4947V29.9133Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0876 38.4737L12.4656 41.0957C10.2493 39.6284 7.2814 40.0786 5.59939 42.1371C3.91763 44.1956 4.06847 47.1935 5.9479 49.0732C7.82707 50.9529 10.8255 51.1032 12.884 49.4215C14.9422 47.7395 15.3926 44.7718 13.9251 42.5552L16.5468 39.9335L15.0876 38.4737ZM9.62344 48.4939C7.91348 48.4939 6.52694 47.1074 6.52694 45.3971C6.52694 43.6867 7.91348 42.3004 9.62344 42.3004C10.084 42.3019 10.537 42.4075 10.9502 42.6098L8.89408 44.6667L10.3533 46.126L12.411 44.0706C12.6131 44.4838 12.7189 44.9371 12.7205 45.3971C12.7205 47.1074 11.3344 48.4939 9.62344 48.4939Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 42.301H31.3011V44.366H17.8819V42.301Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8819 46.4296H25.1075V48.494H17.8819V46.4296Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1722 46.4296H31.3011V48.494H27.1722V46.4296Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.85 62.946C57.4019 62.946 64.3335 56.013 64.3335 47.4619C64.3335 38.91 57.4019 31.9778 48.85 31.9778C40.2981 31.9778 33.3659 38.91 33.3659 47.4619C33.376 56.0091 40.3023 62.9356 48.85 62.946ZM48.85 34.0425C56.2609 34.0425 62.2694 40.0505 62.2694 47.4619C62.2694 54.8733 56.2609 60.881 48.85 60.881C41.4384 60.881 35.4301 54.8733 35.4301 47.4619C35.4389 40.0541 41.4417 34.0507 48.85 34.0425Z",
    fill: "#FA541C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5531 48.0322L40.7052 48.9548L42.7699 53.0839C42.9179 53.381 43.2004 53.5887 43.5282 53.6418C43.5815 53.65 43.6348 53.6544 43.6884 53.6552C43.9619 53.6552 44.2245 53.5463 44.4185 53.3527L56.8051 40.9657L55.3458 39.5059L43.9709 50.8803L42.5531 48.0322Z",
    fill: "#FA541C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22414_12642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineMedia);
export default __webpack_public_path__ + "static/media/online_media.8099b0f87f8886a7112453a0b34620fa.svg";
export { ForwardRef as ReactComponent };